<template>
    <div class="casino-page">
        <CasinoLobby />
    </div>
</template>

<script>
import CasinoLobby from '@/components/casino/CasinoLobby.vue';

export default {
    name: 'Casino',
    components: {
        CasinoLobby
    },
    metaInfo: {
        title: 'Casino - Lobby'
    }
};
</script>

<style scoped>
.casino-page {
    width: 100%;
    display: flex;
    justify-content: center;
    min-height: calc(100vh - 80px);
}
</style>
